var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.808,
    height: 19.85,
    viewBox: "0 0 19.808 19.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M287.571-547.791a2.1,2.1,0,0,0-1.32,1.136l-.253.5v5.612c0,6.253-.029,5.943.68,6.719a2.554,2.554,0,0,0,1.486.777l.262.058v4.9l2.457-2.447,2.447-2.447,5.243-.029c5.981-.029,5.719,0,6.535-.893.728-.8.7-.476.7-6.641v-5.515l-.253-.505a2.861,2.861,0,0,0-.6-.8c-.728-.6-.447-.583-9.088-.573C289.581-547.927,287.9-547.9,287.571-547.791Z",
    transform: "translate(-285.998 547.93)",
    fill: "#939a9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat__icon.91aac1829a84f94ca837c991c39f791f.svg";
export { ForwardRef as ReactComponent };